export default {"id":"6c3505dc","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}